module.exports = __webpack_public_path__ + "media/乐器演奏-民族扬琴.4b6e77fa.wav";